import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}
export const tooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>
      Click to clear the location, section, room, and bed for this resident. You must also click Save to stop tracking the resident for this location.
    </p>
  </Tooltip>
);